// import { Theme } from '@mui/material/styles';
// import { LoadingButtonProps, LoadingButtonClassKey }from '@mui/lab/LoadingButton';

// ----------------------------------------------------------------------

// export function loadingButton(theme: Theme) {
//   return {
//     MuiLoadingButton: {
//       styleOverrides: {
//         root: ({ ownerState }: { ownerState: LoadingButtonProps }) => ({
//           ...(ownerState.variant === 'soft' && {
//             [`& .${LoadingButtonClassKey.loadingIndicatorStart}`]: {
//               left: 10,
//             },
//             [`& .${LoadingButtonClassKey.loadingIndicatorEnd}`]: {
//               right: 14,
//             },
//             ...(ownerState.size === 'small' && {
//               [`& .${LoadingButtonClassKey.loadingIndicatorStart}`]: {
//                 left: 10,
//               },
//               [`& .${LoadingButtonClassKey.loadingIndicatorEnd}`]: {
//                 right: 10,
//               },
//             }),
//           }),
//         }),
//       },
//     },
//   };
// }

import { Theme } from '@mui/material/styles';
import { LoadingButtonProps } from '@mui/lab/LoadingButton';

// ----------------------------------------------------------------------

export function loadingButton(theme: Theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: LoadingButtonProps }) => ({
          ...(ownerState.variant === 'soft' && {
            '& .MuiLoadingButton-loadingIndicatorStart': {
              left: 10,
            },
            '& .MuiLoadingButton-loadingIndicatorEnd': {
              right: 14,
            },
            ...(ownerState.size === 'small' && {
              '& .MuiLoadingButton-loadingIndicatorStart': {
                left: 10,
              },
              '& .MuiLoadingButton-loadingIndicatorEnd': {
                right: 10,
              },
            }),
          }),
        }),
      },
    },
  };
}